import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "counter", "submit"];
  static values = {
    minLength: { type: Number, default: 10 },
    maxLength: { type: Number, default: 1000 },
  };
  connect() {
    if (this.hasInputTarget) {
      this.updateCounter();
    }
    this.validateForm();
  }

  updateCounter() {
    if (!this.hasCounterTarget) return;

    const currentLength = this.inputTarget.value.length;
    const maxLength = this.maxLengthValue;

    this.counterTarget.textContent = `${currentLength}/${maxLength}`;
    this.updateCounterStyle(currentLength);
    this.validateForm();
  }

  updateCounterStyle(currentLength) {
    if (!this.hasCounterTarget) return;

    const isValid = currentLength >= this.minLengthValue;
    const isClose = currentLength >= this.maxLengthValue * 0.9;

    this.counterTarget.classList.toggle("text-green-500", isValid && !isClose);
    this.counterTarget.classList.toggle("text-yellow-500", isClose);
    this.counterTarget.classList.toggle("text-slate-500", !isValid);
  }

  validateForm() {
    if (!this.hasSubmitTarget) return;

    const isValid = this.inputTarget.value.length >= this.minLengthValue;
    this.submitTarget.disabled = !isValid;
    this.submitTarget.classList.toggle("opacity-50", !isValid);
    this.submitTarget.classList.toggle("cursor-not-allowed", !isValid);
  }
}
